module.exports = __webpack_public_path__ + "img/align_vertical_center.4905a7eb.svg";